module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"1":"Labels","2":"Aucun label associé.","3":"Associer des labels à ce dossier"},"en":{"1":"Labels","2":"No label.","3":"Tag this CV with labels"}}')
  delete Component.options._Ctor
}
